
import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Select from 'react-select';
import ColorPicker from 'react-best-gradient-color-picker'

import { useEffect, useRef, useState } from 'react';
import { fetchAvailableGoogleFonts, fetchCustomizationsSetting, fetchUpdateCustomizations } from './CustomizationsApi';
import './CustomizationsScreen.css'

import page_img from '../../components/Navigation/icons/personalizations.svg'
import color_icon from './images/color.svg'
import gradient_icon from './images/gradient.svg'
import image_icon from './images/image.svg'

import CustomizationCard from './CustomizationCard';
import { API_URL } from '../../config/constants';
import UploadButton from '../../components/UploadButton';
import urlFileUploader from '../../services/uploader/urlFileUploader';
import SecureImage from '../../components/SecureImage';
import { setLoading } from '../../services/global/globalSlice';
import { loadAppCustomizationsData } from '../../services/utils/appInfoSlice';

import { useTour } from "@reactour/tour"
import { selectUserData, selectUserOnboarding } from "../../features/User/userSlice"
import { personalizationTourSteps } from "../../config/tour"

const defaultPersonalizationsData = {
        "app_short_name": "",
        "app_name": "",
        "text": {
            "font_url": "",
            "color": ""
        },
        "link": {
            "font_url": "",
            "color": ""
        },
        "h1": {
            "font_url": "",
            "color": ""
        },
        "h2": {
            "font_url": "",
            "color": ""
        },
        "h3": {
            "font_url": "",
            "color": ""
        },
        "primary_button": {
            "border": {
            "depth": 0,
            "color": ""
            },
            "corner_radius": 0,
            "background_color": "",
            "text": {
            "font_url": "",
            "color": ""
            }
        },
        "secondary_button": {
            "border": {
            "depth": 0,
            "color": ""
            },
            "corner_radius": 0,
            "background_color": "",
            "text": {
            "font_url": "",
            "color": ""
            }
        },
        "background": {
            "color": ""
        },
        "icon_set": "colored",
        "logo_url": "",
        "logo_icon_url": "",
        "privacy_document_url": ""
}

export default function CustomizationsHome () {

    const t = useSelector(selectTranslations)
    const [personalizationsData, setPersonalizationsData] = useState(defaultPersonalizationsData)
    const [isUpdated, setIsUpdated] = useState(false)
    const [fontOptions, setFontOptions] = useState([])
    const [activeKey, setActiveKey] = useState('general')
    let uploadFile = useRef()
    const dispatch = useDispatch()

    const loadPersonalizationsData = async () => {
        dispatch(setLoading(true))
        const response = await fetchCustomizationsSetting()
        if(response.success){
            setPersonalizationsData(response.data)
            dispatch(setLoading(false))
        } else {
            toast.error(t.personalizations.error_loading, {
                position: "top-center"
            });
            dispatch(setLoading(false))
        }
    }

    const handleUpdatePersonalization = (element, value) => {
        setIsUpdated(true)
        setPersonalizationsData({
            ...personalizationsData,
            [element]: value
        })
    }
    const handleUpdateActiveSection = (element, value) => {
        setIsUpdated(true)
        setPersonalizationsData({
            ...personalizationsData,
            enabled_sections: {
                ...personalizationsData?.enabled_sections,
                [element]: value
            }
        })
    }
    const handleFontChange = async (value, weight) => {
        let file_url = value?.files[weight]
        if(!file_url)
            switch(weight){
                case 100:{
                    file_url=value?.files['regular']
                } break;
                case 500:{
                    file_url=value?.files['regular']
                } break;
                case 700:{
                    file_url=value?.files['bold']
                }
            }
        if(!file_url)
            file_url= value?.files[100] || value?.files['regular']
        const upload_font = await urlFileUploader('personalization', file_url)
        if(upload_font !== 0)
            return {success: true, url: upload_font}
        else    
            return {success: false}
    }
    const handleUpdateFontPersonalization = async (value, element, key, weight=500) => {
        setIsUpdated(true)
            if(key==='font'){
                const response = await handleFontChange(value, weight)
                if(response.success){
                    setPersonalizationsData({
                        ...personalizationsData,
                        [element]: {
                            ...personalizationsData[element],
                            font_url: response.url,
                            font_family: value?.family
                        }
                    })
                    toast.success(t.personalizations.font_success)
                } else {
                    toast.error(t.personalizations.error_loading)
                }
            } else if(key==='color'){
                setPersonalizationsData({
                    ...personalizationsData,
                    [element]: {
                        ...personalizationsData[element],
                        color: value
                    }
                })
            }
    }
    const handleUpdateButtonPersonalization = async (value, element, key, secondary_key='', weight=500) => {
        setIsUpdated(true)
            if(value){
                if(key==='font'){
                    const response = await handleFontChange(value, weight)
                    if(response.success){
                        setPersonalizationsData({
                            ...personalizationsData,
                            [element]: {
                                ...personalizationsData[element],
                                text: {
                                    ...personalizationsData[element]?.text,
                                    font_url: response.url,
                                    font_family: value?.family
                                }
                            }
                        })
                        toast.success(t.personalizations.font_success)
                    } else {
                        toast.error(t.personalizations.error_loading)
                    }
                } else if(key==='color'){
                    setPersonalizationsData({
                        ...personalizationsData,
                        [element]: {
                            ...personalizationsData[element],
                            text: {
                                ...personalizationsData[element]?.text,
                                color: value
                            }
                        }
                    })
                } else if(key==='border'){
                    setPersonalizationsData({
                        ...personalizationsData,
                        [element]: {
                            ...personalizationsData[element],
                            border: {
                                ...personalizationsData[element]?.border,
                                [secondary_key]: secondary_key === 'depth' ? parseInt(value) : value
                            }
                        }
                    })
                } else {
                    setPersonalizationsData({
                        ...personalizationsData,
                        [element]: {
                            ...personalizationsData[element],
                            [key]: key === 'corner_radius' ? parseInt(value) : value
                        }
                    })
                }
            }
            
    }
    const handleUpdateBackgroundPersonalization = (value, key) => {
        setIsUpdated(true)
        setPersonalizationsData({
            ...personalizationsData,
            background: {
                ...personalizationsData?.background,
                [key]: value
            }
        })
    }
    const resetCustomization = (key) => {
        setIsUpdated(true)
        let currentData =  structuredClone(personalizationsData)
        delete currentData[key]
        setPersonalizationsData({
            ...currentData
        })
    }

    const handleSavePersonalizations = async () => {
        dispatch(setLoading(true))
        const currentData = structuredClone(personalizationsData)
        const _updateData = prepareUpdateData(currentData)
        const response = await fetchUpdateCustomizations(_updateData)
        if(response.success) {
            toast.success(t.personalizations.saved)
            loadPersonalizationsData()
            dispatch(loadAppCustomizationsData())
            dispatch(setLoading(false))
        } else {
            toast.error(t.personalizations.error)
            console.log(response.error)
            dispatch(setLoading(false))
        }
    }

    const loadFontOptions = async (e) => {
        const response = await fetchAvailableGoogleFonts(e?.charAt(0)?.toUpperCase() + e?.slice(1))
        if(response.success){
           setFontOptions(response?.data?.items)
        }
    }

    const prepareUpdateData = (data) => {
        //loop over texts objects and check if they have all the fields otherwise add what's missing
        return data
    }

    useEffect(()=>{
        loadPersonalizationsData()
        loadFontOptions()
    }, [])

    const userOnboarding  = useSelector(selectUserOnboarding)
    const userData = useSelector(selectUserData)
    const { setIsOpen, setCurrentStep, setSteps, setMeta } = useTour()
    
    useEffect(()=>{
        if(!userOnboarding?.personalizations?.section_completed && !userData?.is_super_admin){
            setTimeout(()=>{
                if(window.location.pathname?.includes("settings"))
                    setIsOpen(true)
            },500)
            setSteps(personalizationTourSteps(setActiveKey))
            setCurrentStep(userOnboarding?.personalizations?.step_completed_count)
            setMeta('personalizations')
            switch(userOnboarding?.personalizations?.section_completed){
                case 2:{
                    setActiveKey("logos")
                }
                break;
                default: {
                    setActiveKey("general")
                }
            }
        } 
    },[])

    return (
        <section id="customizationScreen" className='personalizations-step-2'>
            <div className="page_title">
                <img src={page_img} />
                <h1>{t.personalizations.page_title}</h1>
            </div>
            <Tabs
                defaultActiveKey="general"
                id="noanim-tab-example"
                activeKey={activeKey}
                onSelect={(k) => setActiveKey(k)}
                className="mt-3 mb-4 personalizations-step-0"
            >
                <Tab eventKey="general" title={t.personalizations.general}>
                    <CustomizationCard title={t.personalizations.cards.info} className="personalizations-step-1">
                        <Form.Group controlId="app_name">
                            <Form.Label>{t.personalizations.cards.app_name}</Form.Label>
                            <Form.Control type="text" value={personalizationsData?.app_name} onChange={(e)=>handleUpdatePersonalization('app_name',e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mt-2" controlId="app_short_name">
                            <Form.Label>{t.personalizations.cards.app_short_name}</Form.Label>
                            <Form.Control type="text" value={personalizationsData?.app_short_name} onChange={(e)=>handleUpdatePersonalization('app_short_name',e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mt-2" controlId="privacy">
                            <Form.Label>{t.personalizations.cards.privacy}</Form.Label>
                            <div className='d-flex align-items-center'>
                                <div>
                                   <UploadButton onUpload={(e)=>handleUpdatePersonalization('privacy_document_url',e)} type='personalization' label={t.buttons.upload_file} accept='application/pdf' showProgress={true} />
                                </div>
                                <div className='ms-3'>
                                    {personalizationsData?.privacy_document_url ? 
                                        <a href={`${API_URL}${personalizationsData?.privacy_document_url}`} target='_blank' >{t.personalizations.cards.current_document}</a>
                                    : ""}
                                </div>
                            </div>
                            <small>È possibile caricare solo file PDF, massimo 10MB</small>
                        </Form.Group>
                    </CustomizationCard>
                </Tab>
                <Tab eventKey="texts" title={t.personalizations.texts}>
                    <CustomizationCard title={t.personalizations.cards.text} handleReset={()=>resetCustomization('text')}>
                        <div className='d-flex justify-content-start'>
                            <Form.Group controlId="h1_font">
                                <Form.Label>{t.personalizations.cards.char}</Form.Label>
                                <Select  
                                    value={fontOptions.find(f=>f.family === personalizationsData?.text?.font_family)}
                                    getOptionLabel = {option => option.family}
                                    getOptionValue = {option => option.family}
                                    onChange={(e)=>handleUpdateFontPersonalization(e,'text','font',500)}
                                    options={fontOptions}
                                    classNamePrefix="react-select-picker"
                                />
                            </Form.Group>
                            <Form.Group controlId="h1_color" className='ms-2'>
                                <Form.Label>{t.personalizations.cards.color}</Form.Label>
                                <Form.Control type="color" value={personalizationsData?.text?.color || ''} onChange={(e)=>handleUpdateFontPersonalization(e.target.value,'text','color')} />
                            </Form.Group>
                        </div>
                    </CustomizationCard>
                    <CustomizationCard title={t.personalizations.cards.link} handleReset={()=>resetCustomization('link')}>
                        <div className='d-flex justify-content-start'>
                            <Form.Group controlId="h1_font">
                                <Form.Label>{t.personalizations.cards.char}</Form.Label>
                                <Select  
                                    value={fontOptions.find(f=>f.family === personalizationsData?.link?.font_family)}
                                    getOptionLabel = {option => option.family}
                                    getOptionValue = {option => option.family}
                                    onChange={(e)=>handleUpdateFontPersonalization(e,'link','font',500)}
                                    options={fontOptions}
                                    
                                    classNamePrefix="react-select-picker"
                                />
                            </Form.Group>
                            <Form.Group controlId="h1_color" className='ms-2'>
                                <Form.Label>{t.personalizations.cards.color}</Form.Label>
                                <Form.Control type="color" value={personalizationsData?.link?.color || ''} onChange={(e)=>handleUpdateFontPersonalization(e.target.value,'link','color')} />
                            </Form.Group>
                        </div>
                    </CustomizationCard>
                    <CustomizationCard title={t.personalizations.cards.h1} handleReset={()=>resetCustomization('h1')}>
                        <div className='d-flex justify-content-start'>
                            <Form.Group controlId="h1_font">
                                <Form.Label>{t.personalizations.cards.char}</Form.Label>
                                <Select  
                                    value={fontOptions.find(f=>f.family === personalizationsData?.h1?.font_family)}
                                    getOptionLabel = {option => option.family}
                                    getOptionValue = {option => option.family}
                                    onChange={(e)=>handleUpdateFontPersonalization(e,'h1','font',700)}
                                    options={fontOptions}
                                    
                                    classNamePrefix="react-select-picker"
                                />
                            </Form.Group>
                            <Form.Group controlId="h1_color" className='ms-2'>
                                <Form.Label>{t.personalizations.cards.color}</Form.Label>
                                <Form.Control type="color" value={personalizationsData?.h1?.color || ''} onChange={(e)=>handleUpdateFontPersonalization(e.target.value,'h1','color')} />
                            </Form.Group>
                        </div>
                    </CustomizationCard>
                    <CustomizationCard title={t.personalizations.cards.h2} handleReset={()=>resetCustomization('h2')}>
                        <div className='d-flex justify-content-start'>
                            <Form.Group controlId="h1_font">
                                <Form.Label>{t.personalizations.cards.char}</Form.Label>
                                <Select  
                                    value={fontOptions.find(f=>f.family === personalizationsData?.h2?.font_family)}
                                    getOptionLabel = {option => option.family}
                                    getOptionValue = {option => option.family}
                                    onChange={(e)=>handleUpdateFontPersonalization(e,'h2','font',700)}
                                    options={fontOptions}
                                    
                                    classNamePrefix="react-select-picker"
                                />
                            </Form.Group>
                            <Form.Group controlId="h1_color" className='ms-2'>
                                <Form.Label>{t.personalizations.cards.color}</Form.Label>
                                <Form.Control type="color" value={personalizationsData?.h2?.color || ''} onChange={(e)=>handleUpdateFontPersonalization(e.target.value,'h2','color')} />
                            </Form.Group>
                        </div>
                    </CustomizationCard>
                    <CustomizationCard title={t.personalizations.cards.h3} handleReset={()=>resetCustomization('h3')}>
                        <div className='d-flex justify-content-start'>
                            <Form.Group controlId="h1_font">
                                <Form.Label>{t.personalizations.cards.char}</Form.Label>
                                <Select  
                                    value={fontOptions.find(f=>f.family === personalizationsData?.h3?.font_family)}
                                    getOptionLabel = {option => option.family}
                                    getOptionValue = {option => option.family}
                                    onChange={(e)=>handleUpdateFontPersonalization(e,'h3','font',700)}
                                    options={fontOptions}
                                    classNamePrefix="react-select-picker"
                                />
                            </Form.Group>
                            <Form.Group controlId="h1_color" className='ms-2'>
                                <Form.Label>{t.personalizations.cards.color}</Form.Label>
                                <Form.Control type="color" value={personalizationsData?.h3?.color || ''} onChange={(e)=>handleUpdateFontPersonalization(e.target.value,'h3','color')} />
                            </Form.Group>
                        </div>
                    </CustomizationCard>
                </Tab>
                <Tab eventKey="buttons" title={t.personalizations.buttons}>
                    <CustomizationCard title={t.personalizations.cards.primary_button} handleReset={()=>resetCustomization('primary_button')}>
                        <div className='d-flex justify-content-between'>
                            <Form.Group controlId="button_border">
                                <Form.Label>{t.personalizations.cards.border}</Form.Label>
                                <div className='d-flex'>
                                    <Form.Control type="number" value={personalizationsData?.primary_button?.border?.depth } onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'primary_button','border','depth')} />
                                    <Form.Control type="color" className='ms-2' value={personalizationsData?.primary_button?.border?.color || ''} onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'primary_button','border','color')} />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="button_radius">
                                <Form.Label>{t.personalizations.cards.corner}</Form.Label>
                                <Form.Control type="number" value={personalizationsData?.primary_button?.corner_radius } min={0} onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'primary_button','corner_radius')} />
                            </Form.Group>
                            <Form.Group controlId="button_bg">
                                <Form.Label>{t.personalizations.cards.background}</Form.Label>
                                <Form.Control type="color" value={personalizationsData?.primary_button?.background_color || ''} onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'primary_button','background_color')} />
                            </Form.Group>
                        </div>
                        <div className='d-flex mt-3 justify-content-between'>
                            <Form.Group controlId="primary_font">
                                <Form.Label>{t.personalizations.cards.text_color}</Form.Label>
                                <div className='d-flex'>
                                    <Select  
                                        options={fontOptions}
                                        getOptionLabel = {option => option.family}
                                        getOptionValue = {option => option.family}
                                        onChange={(e)=>handleUpdateButtonPersonalization(e,'primary_button','font','',700)}
                                        value={fontOptions.find(f=>f.family === personalizationsData?.primary_button?.text?.font_family)}
                                        classNamePrefix="react-select-picker"
                                    />
                                    <Form.Control className='ms-2' type="color" value={personalizationsData?.primary_button?.text?.color || ''} onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'primary_button','color')} />
                                </div>
                            </Form.Group>
                        </div>
                    </CustomizationCard>
                    <CustomizationCard title={t.personalizations.cards.secondary_button} handleReset={()=>resetCustomization('secondary_button')}>
                        <div className='d-flex justify-content-between'>
                            <Form.Group controlId="button_border">
                                <Form.Label>{t.personalizations.cards.border}</Form.Label>
                                <div className='d-flex'>
                                    <Form.Control type="number" value={personalizationsData?.secondary_button?.border?.depth } onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'secondary_button','border','depth')} />
                                    <Form.Control className='ms-2' type="color" value={personalizationsData?.secondary_button?.border?.color || ''} onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'secondary_button','border','color')} />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="button_radius">
                                <Form.Label>{t.personalizations.cards.corner}</Form.Label>
                                <Form.Control type="number" value={personalizationsData?.secondary_button?.corner_radius } min={0} onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'secondary_button','corner_radius')} />
                            </Form.Group>
                            <Form.Group controlId="button_bg">
                                <Form.Label>{t.personalizations.cards.background}</Form.Label>
                                <Form.Control type="color" value={personalizationsData?.secondary_button?.background_color || ''} onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'secondary_button','background_color')} />
                            </Form.Group>
                        </div>
                        <div className='d-flex mt-3 justify-content-between'>
                            <Form.Group controlId="primary_font">
                                <Form.Label>{t.personalizations.cards.text_color}</Form.Label>
                                <div className='d-flex'>
                                    <Select  
                                        options={fontOptions}
                                        getOptionLabel = {option => option.family}
                                        getOptionValue = {option => option.family}
                                        onChange={(e)=>handleUpdateButtonPersonalization(e,'secondary_button','font','',700)}
                                        value={fontOptions.find(f=>f.family === personalizationsData?.secondary_button?.text?.font_family)}
                                        classNamePrefix="react-select-picker"
                                    />
                                    <Form.Control type="color" className='ms-2' value={personalizationsData?.secondary_button?.text?.color || ''} onChange={(e)=>handleUpdateButtonPersonalization(e.target.value,'secondary_button','color')} />
                                </div>
                            </Form.Group>
                        </div>
                    </CustomizationCard>
                </Tab>
                <Tab eventKey="background" title={t.personalizations.background}>
                    <CustomizationCard title={t.personalizations.cards.app_background} handleReset={()=>resetCustomization('background')}>
                        <div className='d-flex justify-content-between'>
                            <Form.Group controlId="h1_font">
                                <Form.Label>{t.personalizations.cards.type}</Form.Label>
                                <div className='d-flex'>
                                    <div className='custom-radio'>
                                        <input type="radio" id="color" name="background" value="colored" checked={personalizationsData?.background?.type==="colored"} onClick={(e)=>console.log(e)} onChange={(e)=>handleUpdateBackgroundPersonalization(e.target.value,'type')}/>
                                        <label htmlFor="color">
                                            <img src={color_icon} className="me-1" />
                                            {t.personalizations.cards.color}
                                        </label>
                                    </div>
                                    <div className='custom-radio ms-2'>
                                        <input type="radio" id="gradient" name="background" value="gradient" checked={personalizationsData?.background?.type==="gradient"} onChange={(e)=>handleUpdateBackgroundPersonalization(e.target.value,'type')} />
                                        <label htmlFor="gradient">
                                            <img src={gradient_icon} className="me-1" />
                                            {t.personalizations.cards.gradient}
                                        </label>
                                    </div>
                                    <div className='custom-radio ms-2'>
                                        <input type="radio" id="image" name="background" value="image" checked={personalizationsData?.background?.type==="image"} onChange={(e)=>handleUpdateBackgroundPersonalization(e.target.value,'type')}/>
                                        <label htmlFor="image">
                                            <img src={image_icon} className="me-1" />
                                            {t.personalizations.cards.image}
                                        </label>
                                    </div>
                                </div>
                                <div className='mt-3'>
                                    {   personalizationsData?.background?.type==="colored" ? 
                                        <Form.Group controlId="bg_color">
                                            <Form.Control type="color" value={personalizationsData?.background?.color} onChange={(e)=>handleUpdateBackgroundPersonalization(e.target.value,'color')} />
                                        </Form.Group> : ""
                                    }
                                    {   personalizationsData?.background?.type==="gradient" ? 
                                        <Form.Group controlId="bg_gradient">
                                            <ColorPicker value={personalizationsData?.background?.gradient_css_rule} hideAdvancedSliders={true} hidePresets={true} onChange={(e)=>handleUpdateBackgroundPersonalization(e,'gradient_css_rule')} />
                                        </Form.Group> : ""
                                    }
                                    {   personalizationsData?.background?.type==="image" ? 
                                        <Form.Group controlId="bg_image">
                                            <UploadButton onUpload={(e)=>handleUpdateBackgroundPersonalization(e,'image_url')} type='personalization' label={t.buttons.upload_file} accept='image/png, image/jpeg, image/jpg' showProgress={true} />
                                            {personalizationsData.background.image_url ? 
                                                <img src={`${API_URL}${personalizationsData.background.image_url}`} />
                                            : ""}
                                        </Form.Group> : ""
                                    }
                                </div>
                            </Form.Group>
                        </div>
                    </CustomizationCard>
                </Tab>
                <Tab eventKey="logos" title={t.personalizations.logos} >
                    <CustomizationCard title={t.personalizations.cards.logo} >
                        <Form.Group className="mt-2" controlId="logo">
                            <Form.Label>{t.personalizations.cards.image}</Form.Label>
                            <div className='d-flex align-items-start'>
                                <div>
                                   <UploadButton onUpload={(e)=>handleUpdatePersonalization('logo_url',e)} type='personalization' label={t.buttons.upload_file} accept='image/*' showProgress={true} />
                                    <span>{t.personalizations.cards.suggested_size_logo}</span>
                                </div>
                                <div className='ms-3'>
                                    {personalizationsData?.logo_url ? 
                                        <img src={`${API_URL}${personalizationsData?.logo_url}`} />
                                    : ""}
                                </div>
                            </div>
                        </Form.Group>
                    </CustomizationCard>
                    <CustomizationCard title={t.personalizations.cards.icon_logo}>
                        <Form.Group className="mt-2" controlId="icon">
                            <Form.Label>{t.personalizations.cards.image}</Form.Label>
                            <div className='d-flex align-items-start'>
                                <div>
                                   <UploadButton onUpload={(e)=>handleUpdatePersonalization('logo_icon_url',e)} type='personalization' label={t.buttons.upload_file} accept='image/*' showProgress={true} />
                                    <span>{t.personalizations.cards.suggested_size_icon}</span>
                                </div>
                                <div className='ms-3'>
                                    {personalizationsData?.logo_icon_url ? 
                                        <img src={`${API_URL}${personalizationsData?.logo_icon_url}`} />
                                    : ""}
                                </div>
                            </div>
                        </Form.Group>
                    </CustomizationCard>
                </Tab>
                <Tab eventKey="sections" title={t.personalizations.sections}>
                    <CustomizationCard title={t.personalizations.cards.active_sections}>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="trainings"
                            name="trainings"
                            label={t.personalizations.cards.training_section}
                            onChange={(e)=>handleUpdateActiveSection('trainings',e.target.checked)}
                            checked={personalizationsData?.enabled_sections?.trainings}
                        />
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="exams"
                            name="exams"
                            label={t.personalizations.cards.exam_section}
                            onChange={(e)=>handleUpdateActiveSection('exams',e.target.checked)}
                            checked={personalizationsData?.enabled_sections?.exams}
                        />
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="notifications"
                            name="notifications"
                            label={t.personalizations.cards.notification_section}
                            onChange={(e)=>handleUpdateActiveSection('notifications',e.target.checked)}
                            checked={personalizationsData?.enabled_sections?.notifications}
                        />
                    </CustomizationCard>
                </Tab>
            </Tabs>
            <footer className='control-footer'>
                <div className='d-flex justify-content-end'>
                    <button disabled={!isUpdated} className={isUpdated && "highlight"} onClick={handleSavePersonalizations}>
                        {t.buttons.edit_save}
                    </button>
                </div>
            </footer>
        </section>
    )
}